import React, { useState } from 'react';
import { Card, CardContent, List, ListItem } from '@mui/material';
import { DragDropContext, Droppable, Draggable, } from 'react-beautiful-dnd';
import { Icon } from '../../../../atoms';
import { Typography } from '../../../../electrons';
import { SearchField } from '../../../formFields';
import ColumnSelectorCardItem from '../ColumnSelectorCardItem';
import useStyles from './ColumnSelectorCard.styles';
import { reorder } from './ColumnSelectorCard.utils';
export function ColumnSelectorCard({ columns, draggable = false, onAddColumn, onItemClick, onItemPin, onItemUnpin, onItemMove, titleColor, title, }) {
    const classes = useStyles();
    const [search, setSearch] = useState('');
    const TITLE_COLOR = titleColor === 'black-pearl' ? 'inherit' : 'primary';
    const onSearchChange = (e) => {
        setSearch(e.target.value);
    };
    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        const reorderedColumns = reorder(columns, result.source.index, result.destination.index);
        onItemMove === null || onItemMove === void 0 ? void 0 : onItemMove(reorderedColumns);
    };
    const getFilteredColumns = () => {
        return columns.filter((column) => {
            const label = column.label;
            return label.toLocaleLowerCase().includes(search.toLocaleLowerCase());
        });
    };
    const getSearchId = () => {
        if (title.includes('Event')) {
            return 'search_events';
        }
        else if (title.includes('Metric')) {
            return 'search_metrics';
        }
        else if (title.includes('Available')) {
            return 'search_available';
        }
        else if (title.includes('Selected')) {
            return 'search_selected';
        }
    };
    const renderListItem = (column) => (React.createElement(ColumnSelectorCardItem, { key: column.value, column: column, onItemClick: onItemClick, onItemPin: onItemPin, onItemUnpin: onItemUnpin }));
    const renderDraggableListItem = (column, index) => (React.createElement(Draggable, { key: column.value, draggableId: column.value, index: index }, (dragProvided) => (React.createElement("div", Object.assign({ id: "list-item-draggable", className: classes.draggableConsumer, ref: dragProvided.innerRef }, dragProvided.draggableProps, dragProvided.dragHandleProps), renderListItem(column)))));
    const renderDraggableList = () => (React.createElement(DragDropContext, { onDragEnd: onDragEnd },
        React.createElement(Droppable, { droppableId: `dnd-droppable-${title}` }, (dropProvided) => (React.createElement("div", Object.assign({}, dropProvided.droppableProps, { ref: dropProvided.innerRef }),
            getFilteredColumns().map((column) => column.alwaysEnabled && renderListItem(column)),
            getFilteredColumns().map((column, index) => !column.alwaysEnabled && renderDraggableListItem(column, index)))))));
    const renderStaticList = () => getFilteredColumns().map(renderListItem);
    const renderAddColumnButton = () => {
        if (!onAddColumn) {
            return null;
        }
        return (React.createElement(ListItem, { className: classes.addItem, onClick: onAddColumn },
            React.createElement(Icon, { id: "add-column-icon", className: classes.icon }, "add"),
            "Custom ",
            title));
    };
    return (React.createElement(Card, { className: classes.root },
        React.createElement(Typography, { id: "card-title", className: classes.header, variant: "h4", color: TITLE_COLOR },
            title,
            " Columns"),
        React.createElement(CardContent, { className: classes.content },
            React.createElement("div", null,
                React.createElement(SearchField, { id: getSearchId(), placeholder: `Search ${title}`, value: search, onChange: onSearchChange, fullWidth: true })),
            React.createElement(List, null,
                renderAddColumnButton(),
                draggable ? renderDraggableList() : renderStaticList()))));
}
//# sourceMappingURL=ColumnSelectorCard.js.map